<!--
 * @Author: yang.yang
 * @Description: 圆形头像组件（在外层容器定义宽高）
 -->

<template>
  <div class="avatar">
    <img
      class="head-portrait-box"
      :src="portraitSrc"
      @load="portraitLoaded = true"
      :style="{ opacity: portraitLoaded ? 1 : 0 }"
      alt=""
    />
    <img
      class="avatar-img"
      :src="srcComputed"
      @load="loaded = true"
      :style="{
        opacity: loaded ? 1 : 0,
        background: portraitLoaded ? 'none' : '#F9F9F9'
      }"
      :class="{ 'has-head-portrait-box': portraitLoaded }"
      alt=""
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      loaded: false,
      portraitLoaded: false
    };
  },
  props: {
    src: String,
    portrait: String
  },
  computed: {
    srcComputed() {
      const src = this.src;
      if (!src) return '';
      return /\?d=|gif/.test(src) ? src : src + '?d=200x200';
    },
    portraitSrc() {
      const src = this.portrait;
      if (!src) return '';
      return /\?d=|gif/.test(this.portrait) ? src : src + '?d=200x200';
    }
  }
};
</script>

<style lang="scss" scoped>
.avatar {
  position: relative;
  width: 100%;
  height: 100%;
  .avatar-img,
  .head-portrait-box {
    display: block;
    width: 100%;
    height: 100%;
    transition: opacity 0.15s;
  }
  .avatar-img {
    border-radius: 50%;
    object-fit: cover;
  }
  .head-portrait-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(1.4);
    z-index: 2;
    width: 100%;
    height: auto;
  }
}
</style>
